import script from "./PixelBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./PixelBackground.vue?vue&type=script&setup=true&lang=js"

import "./PixelBackground.vue?vue&type=style&index=0&id=c82bb786&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c82bb786"]])

export default __exports__